import React, { useEffect, useState } from "react";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  Button,
  ListGroup,
  ListGroupItem,
  CardFooter,
} from "reactstrap";
import partnerService from "../../services/KangarooServices/PartnerService";
import { Link, useNavigate } from "react-router-dom";
import { Triangle } from "react-loader-spinner";

const Partners = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const fetchData = async () => {
    setLoading(true);
    try {
      const result = await partnerService.getList();
      setData(result);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleDeleteClick = async (id) => {
    try {
      await partnerService.delete(id);
      fetchData();
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb title="Partners" pageTitle="User Management" />

        <Row className="mb-4">
          <Col className="col-auto">
            <Button color="success" onClick={() => navigate("/addpartner")}>
              <i className="ri-add-line align-bottom me-1"></i> Add Partner
            </Button>
          </Col>
        </Row>

        {loading ? (
          <div className="my-3 d-flex justify-content-center align-items-center">
            <Triangle height="100" width="100" color="#556ee6" />
          </div>
        ) : data?.length === 0 ? (
          <Row>
            <Col>
              <p>No partners available. Please add a partner.</p>
            </Col>
          </Row>
        ) : (
          <Row className="g-4">
            {data?.map((partner) => (
              <Col md={4} key={partner.id} className="mb-4">
                <Card
                  className="shadow-sm border-0 h-100 position-relative hover-shadow cursor-pointer"
                  style={{ transition: "all 0.3s", overflow: "hidden" }}
                >
                  <CardBody
                    onClick={() => navigate(`/partnerdetails/${partner.id}`)}
                  >
                    {/* Partner Name */}
                    <CardTitle tag="h5" className="mb-3 fw-bold">
                      {partner.name}
                    </CardTitle>

                    {/* Partner Details */}
                    <ListGroup flush>
                      {partner.partnerDetails.map((detail) => (
                        <ListGroupItem
                          key={detail.id}
                          className="px-0 py-1 border-0 d-flex justify-content-between align-items-center"
                        >
                          <Link
                            to={`/partnerdetails/${detail.id}`}
                            style={{ textDecoration: "none", color: "#495057" }}
                          >
                            {detail.name}{" "}
                            <span className="text-muted">
                              (Order: {detail.orderIndex})
                            </span>
                          </Link>
                        </ListGroupItem>
                      ))}
                    </ListGroup>
                  </CardBody>

                  {/* Edit/Delete Buttons */}
                  <CardFooter className="bg-white border-0 d-flex gap-2 justify-content-end">
                    <Button
                      color="warning"
                      size="sm"
                      onClick={(e) => {
                        e.stopPropagation(); // Prevent card click
                        navigate(`/addpartner/${partner.id}`);
                      }}
                      title="Edit Partner"
                    >
                      <i className="ri-edit-line"></i>{" "}
                    </Button>

                    <Button
                      color="danger"
                      size="sm"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleDeleteClick(partner.id);
                      }}
                      title="Delete Partner"
                    >
                      <i className="ri-delete-bin-line"></i>{" "}
                    </Button>
                  </CardFooter>
                </Card>
              </Col>
            ))}
          </Row>
        )}
      </Container>
    </div>
  );
};

export default Partners;
